export default "https://cdn-static.gokick.com/assets/29e4076df1e4180397d7539366c975103b08717a/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";